import ApplicationModel, { attr } from '../ApplicationModel';
import { type IdeaThemeAttributes } from './generated/IdeaThemeAttributes';
import { model } from '../modelBuilder';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface IdeaTheme extends IdeaThemeAttributes, IColorAttribute {}

@model
@ColorAttribute()
class IdeaTheme extends ApplicationModel {
  // Start auto-generated
  static typename: 'IdeaTheme' = 'IdeaTheme';
  get typename(): 'IdeaTheme' {
    return 'IdeaTheme';
  }

  static internalTypename: 'Ideas::IdeaTheme' = 'Ideas::IdeaTheme';
  get internalTypename(): 'Ideas::IdeaTheme' {
    return 'Ideas::IdeaTheme';
  }

  static terminologyName = 'Idea theme';

  static inputType = 'IdeaThemeAttributes!';

  static filterType = 'IdeaThemeFilters!';
  static filters = { id: '[ID!]', projectId: 'ID', query: 'String' };

  static fields = {
    color: attr({ readable: true }),
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    ideasCount: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Project',
    }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    comments: attr.hasMany({ readable: true }),
    ideas: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default IdeaTheme;
